import { useQuery } from '@tanstack/react-query';
import { fetchActiveSystemMessages, releasesKeys } from '../api';

// Poll cada 5 min por si el admin publica un warning nuevo durante la sesión.
export function useSystemMessages() {
  return useQuery({
    queryKey: releasesKeys.systemMessages(),
    queryFn: fetchActiveSystemMessages,
    staleTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
  });
}
